import { $T } from 'client/library/translation'
import type { FrameMenuItem } from 'app/types'
import type { ServiceInitArgs } from 'app/services/base'
import { useWorkspaceStore } from 'app/services/pinia/workspace-store'

export function buildLabelsMenu(services: ServiceInitArgs, args: { labelsForDelete: readonly string[] }) {
  const { action } = services
  if (!action) {
    return []
  }

  const workbook = useWorkspaceStore().workbook
  if (!workbook) return []

  const menus: FrameMenuItem[] = [
    {
      label: $T('Delete'),
      enable: workbook.getAction('editor.removeTopicLabel').isEnabled,
      action: () => workbook.getAction('editor.removeTopicLabel').execute({ payload: { labels: args.labelsForDelete } }),
    },
  ]
  return menus
}
